import { TInfoMessage, TUser } from "../comonTypes"


export enum EAppAction {
    SET_INFO_MESSAGE = 'APP.SET_INFO_MESSAGE',
    SET_TOKEN = 'APP.SET_TOKEN',
}

interface setAppInfoMessage {
    type: EAppAction.SET_INFO_MESSAGE,
    payload?: TInfoMessage
}

interface setAppToken {
    type: EAppAction.SET_TOKEN,
    payload?: string
}

export type TAppAction = setAppInfoMessage | setAppToken